import { FilterModalTextInput } from '../../../../sharedComponents/filter/FilterModal';
import { useOnChangeTextFilter } from '../../../../sharedComponents/filter/useOnChangeTextFilter';
import { CompoundFilterProps } from './CompoundFilterProps';
import { FunctionComponent } from 'react';

export const ArrivalFromFilter: FunctionComponent<CompoundFilterProps & { expected: boolean }> = ({
    localFilters,
    setLocalFilters,
    expected,
}) => {
    const handleChange = useOnChangeTextFilter('arrivalFromFilter', setLocalFilters);

    return (
        <FilterModalTextInput
            id="arrival-from-filter"
            headerMessageId={
                expected
                    ? 'outboundOrderBook.compoundManagement.filter.arrivingFromLocation'
                    : 'outboundOrderBook.compoundManagement.filter.arrivedFromLocation'
            }
            inputAddon="rioglyph rioglyph-load-unload"
            placeholderMessageId="outboundOrderBook.common.filter.enterLocation"
            isOptional
            value={localFilters.arrivalFromFilter}
            onChange={handleChange}
        />
    );
};
